import {
  AddEmailRecipientAction,
  AddSMSRecipientAction,
  ChangeEmailIntervalAction,
  ChangeSMSIntervalAction,
  FetchCustomerAlarmsAction,
  FetchCustomerAlarmsFailAction,
  FetchCustomerAlarmsSuccessAction,
  RemoveEmailRecipientAction,
  RemoveSMSRecipientAction,
  SaveCustomerAlarmsSuccessAction,
  SetEmailEnabledAction,
  SetSMSEnabledAction,
  SetTemperatureAlertsEnabledAction,
  UpdateSMSRecipientTextBoxAction,
  UpdateTemperatureAlertLowerLimitAction,
  UpdateTemperatureAlertUpperLimitAction
} from './setting-actions'
import { type SettingsState } from './settings-type'
import { createReducer } from '@reduxjs/toolkit'

export const initialSettingsState: SettingsState = {
  loading: 0,
  settingsTab: 0,
  addDialogOpen: false,
  alarmSettingsCustomer: null,
  smsRecipientToAdd: '',
  alarmSettingsDirty: false,
  alarmSettings: {
    emailEnabled: false,
    emailInterval: 1,
    emailRecipients: [],
    smsEnabled: false,
    smsInterval: 1,
    smsRecipients: [],
    temperatureAlertsEnabled: false,
    temperatureAlertLowerLimit: 0,
    temperatureAlertUpperLimit: 90
  }
}

export const settingsReducer = createReducer(initialSettingsState, builder => {
  builder.addCase(SetEmailEnabledAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.emailEnabled = action.payload.enabled
  }).addCase(FetchCustomerAlarmsAction, (state, _action) => {
    state.loading += 1
  }).addCase(FetchCustomerAlarmsSuccessAction, (state, action) => {
    state.loading -= 1
    state.alarmSettingsDirty = false
    state.alarmSettings = action.payload.data
    state.alarmSettingsCustomer = action.payload.id
  }).addCase(FetchCustomerAlarmsFailAction, (state, _action) => {
    state.loading -= 1
  }).addCase(SaveCustomerAlarmsSuccessAction, (state, action) => {
    state.alarmSettingsDirty = false
    state.alarmSettings = action.payload.data
    state.alarmSettingsCustomer = action.payload.id
  }).addCase(AddEmailRecipientAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.emailRecipients.push(action.payload)
  }).addCase(RemoveEmailRecipientAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings = {
      ...state.alarmSettings,
      emailRecipients: state.alarmSettings.emailRecipients.filter(val => {
        return val !== action.payload
      })
    }
  }).addCase(ChangeEmailIntervalAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.emailInterval = action.payload
  }).addCase(SetSMSEnabledAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.smsEnabled = action.payload.enabled
  }).addCase(SetTemperatureAlertsEnabledAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.temperatureAlertsEnabled = action.payload.enabled
  }).addCase(UpdateTemperatureAlertLowerLimitAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.temperatureAlertLowerLimit = action.payload
  }).addCase(UpdateTemperatureAlertUpperLimitAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.temperatureAlertUpperLimit = action.payload
  }).addCase(AddSMSRecipientAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.smsRecipients.push(action.payload)
  }).addCase(RemoveSMSRecipientAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.smsRecipients = state.alarmSettings.smsRecipients.filter(val => {
      return val !== action.payload
    })
  }).addCase(UpdateSMSRecipientTextBoxAction, (state, action) => {
    state.smsRecipientToAdd = action.payload
  }).addCase(ChangeSMSIntervalAction, (state, action) => {
    state.alarmSettingsDirty = true
    state.alarmSettings.smsInterval = action.payload
  })
})
